import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import { useNavigate } from 'react-router-dom';

export default function SearchBox(search) {
  const [query, setQuery] = useState('');
  const navivgate = useNavigate();

  const submitHandler = (e) => {
    e.preventDefault();
    if (search.searchItem === 'products') {
      navivgate(query ? `/search/?query=${query}` : `/search`);
    } else if (search.searchItem === 'customer') {
      navivgate(query ? `/searchcustomer/?query=${query}` : `/searchcustomer`);
    }
  };
  return (
    <Form className="d-flex me-auto" onSubmit={submitHandler}>
      <InputGroup>
        <FormControl
          type="tex"
          name="q"
          id="q"
          onChange={(e) => setQuery(e.target.value)}
          placeholder={`Search ${search.searchItem}...`}
          aria-label={`Search ${search.searchItem}`}
          aria-describedby="bottom-search"
        ></FormControl>
        <Button variant="outline-primary" type="submit" id="button-search">
          <i className="fas fa-search"></i>
        </Button>
      </InputGroup>
    </Form>
  );
}
